// extracted by mini-css-extract-plugin
export default {"section":"Cartogram_section__7PkUz","container":"Cartogram_container__O8Y43","title":"Cartogram_title__KouFa"};